import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["innerHTML"]

import { HuonekorttiResponse } from '@/api/models/huonekortti-response';
import { useHakuComponent } from './haku';
import { ref } from 'vue';
import ComHakuResultDetails from './ComHakuResultDetails.vue';
import { TilaResponseExtended } from '@/api/models/tila-response-extended';


export default /*@__PURE__*/_defineComponent({
  __name: 'ComTilaResultTable',
  setup(__props) {

const { tilat, markFindCut, getSearchTermValue } = useHakuComponent()
const openedDetails = ref<HuonekorttiResponse[]>([])

const setDetails = (row: TilaResponseExtended, expanded: boolean) => {
    if (expanded && row.huonekortti) {
        openedDetails.value?.push(row.huonekortti)
    }
    else {
        openedDetails.value = openedDetails.value?.filter(h => h.id !== row.huonekortti?.id)
    }
}

const details = (id: number) => {
    return openedDetails.value?.find((h: HuonekorttiResponse) => h.id === id) 
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, {
    data: _unref(tilat),
    border: "",
    onExpandChange: setDetails
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, { type: "expand" }, {
        default: _withCtx((scope) => [
          (details(scope.row.huonekortti.id))
            ? (_openBlock(), _createBlock(ComHakuResultDetails, {
                key: 0,
                huonekortti: details(scope.row.huonekortti.id)
              }, null, 8, ["huonekortti"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        prop: "tilatunnus",
        label: "Tilatunnus",
        width: "180"
      }, {
        default: _withCtx((scope) => [
          _createVNode(_component_router_link, {
            to: { name: 'Huonekortti', params: { huonekorttiId: scope.row.huonekortti.id } },
            custom: ""
          }, {
            default: _withCtx(({ href, navigate }) => [
              _createVNode(_component_el_link, {
                type: "primary",
                href: href,
                onClick: navigate
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.row.tilatunnus), 1)
                ]),
                _: 2
              }, 1032, ["href", "onClick"])
            ]),
            _: 2
          }, 1032, ["to"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "Pinta-ala",
        prop: "pintaAla"
      }),
      _createVNode(_component_el_table_column, {
        label: "Tilanimike",
        prop: "huonekortti.tilanimike.nimi"
      }),
      _createVNode(_component_el_table_column, {
        label: "Täsmennys",
        "min-width": "250px"
      }, {
        default: _withCtx((scope) => [
          _createElementVNode("span", {
            innerHTML: _unref(markFindCut)(_unref(getSearchTermValue)('tilanimike-tasmennys'), scope.row.huonekortti.toiminta ?? '', false),
            style: {"margin-left":"10px"}
          }, null, 8, _hoisted_1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "Vastuuyksikkö",
        prop: "huonekortti.vastuuyksikko.nimi"
      })
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})